import EmptyPcIcon from './EmptyPcIcon'

export default EmptyPcIcon
